function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-4.8%",
  y: "-170.4%",
  width: "109.7%",
  height: "460.3%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__a"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 6,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0",
  in: "shadowBlurOuter1"
})), React.createElement("filter", {
  x: "-2.2%",
  y: "-87%",
  width: "104.3%",
  height: "298.8%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__c"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
  in: "shadowBlurOuter1"
})), React.createElement("filter", {
  x: "-1.5%",
  y: "-96.1%",
  width: "102.9%",
  height: "340.2%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__e"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0",
  in: "shadowBlurOuter1"
})), React.createElement("filter", {
  x: "-.4%",
  y: "-.2%",
  width: "100.8%",
  height: "100.4%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__i"
}, React.createElement("feMorphology", {
  radius: 1,
  in: "SourceAlpha",
  result: "shadowSpreadInner1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "shadowSpreadInner1",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0",
  in: "shadowInnerInner1"
})), React.createElement("filter", {
  x: "0%",
  y: "0%",
  width: "100%",
  height: "100%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__j"
}, React.createElement("feGaussianBlur", {
  in: "SourceGraphic"
})), React.createElement("filter", {
  x: "0%",
  y: "0%",
  width: "100%",
  height: "100%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__n"
}, React.createElement("feGaussianBlur", {
  in: "SourceGraphic"
})), React.createElement("filter", {
  x: "-1.2%",
  y: "-45.1%",
  width: "102.4%",
  height: "190.1%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__w"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.299053997 0 0 0 0 0.299053997 0 0 0 0 0.299053997 0 0 0 1 0",
  in: "shadowInnerInner1"
})), React.createElement("filter", {
  x: "-17.5%",
  y: "-.5%",
  width: "134.9%",
  height: "101.1%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__y"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  dx: -3,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0",
  in: "shadowInnerInner1"
})), React.createElement("filter", {
  x: "-17.5%",
  y: "-.5%",
  width: "134.9%",
  height: "101.1%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__A"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  dx: -3,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0",
  in: "shadowInnerInner1"
})), React.createElement("filter", {
  x: "-49.1%",
  y: "-5.4%",
  width: "198.3%",
  height: "110.8%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__D"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), React.createElement("feOffset", {
  dy: -2,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), React.createElement("filter", {
  x: "-49.1%",
  y: "-2.8%",
  width: "198.3%",
  height: "105.7%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__G"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), React.createElement("feOffset", {
  dy: -2,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), React.createElement("filter", {
  x: "-49.1%",
  y: "-2.8%",
  width: "198.3%",
  height: "105.7%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__I"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), React.createElement("feOffset", {
  dy: -2,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), React.createElement("filter", {
  x: "-49.1%",
  y: "-1.8%",
  width: "198.3%",
  height: "103.6%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__M"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), React.createElement("feOffset", {
  dy: -2,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614357 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), React.createElement("filter", {
  x: "-2.3%",
  y: "-15%",
  width: "104.6%",
  height: "130%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__Q"
}, React.createElement("feMorphology", {
  radius: 1,
  in: "SourceAlpha",
  result: "shadowSpreadInner1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowSpreadInner1",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7950351 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), React.createElement("feOffset", {
  dy: -1,
  in: "SourceAlpha",
  result: "shadowOffsetInner2"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.800130208 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetInner3"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner3",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner3"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.197067482 0",
  in: "shadowInnerInner3",
  result: "shadowMatrixInner3"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixInner3"
}))), React.createElement("filter", {
  x: "-98.3%",
  y: "-98.3%",
  width: "296.6%",
  height: "296.5%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__T"
}, React.createElement("feMorphology", {
  radius: 1,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
  in: "shadowOffsetOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), React.createElement("filter", {
  x: "-36.8%",
  y: "-110.4%",
  width: "173.6%",
  height: "320.8%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__V"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.612,
  in: "SourceGraphic"
})), React.createElement("filter", {
  x: "-50.9%",
  y: "-38.9%",
  width: "201.9%",
  height: "177.9%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__X"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.612,
  in: "SourceGraphic"
})), React.createElement("filter", {
  x: "-24.9%",
  y: "-38.2%",
  width: "149.7%",
  height: "176.5%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__Y"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.46,
  in: "SourceGraphic"
})), React.createElement("filter", {
  x: "-1.5%",
  y: "-10.3%",
  width: "102.9%",
  height: "117.2%",
  filterUnits: "objectBoundingBox",
  id: "phone_svg__ab"
}, React.createElement("feOffset", {
  dy: -1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
  in: "shadowBlurOuter1"
})), React.createElement("path", {
  d: "M191.284 10.27c105.643 0 191.284-2.55 191.284-5.697C382.568 1.426 265.266 0 191.284 0 117.3 0 0 1.426 0 4.573c0 3.147 85.64 5.698 191.284 5.698z",
  id: "phone_svg__b"
}), React.createElement("path", {
  d: "M191.007 8.605c102.121 0 184.907-2 184.907-4.466S262.523.555 191.007.555C119.49.555 6.099 1.673 6.099 4.14c0 2.467 82.786 4.466 184.908 4.466z",
  id: "phone_svg__d"
}), React.createElement("path", {
  d: "M191.561 6.384c95.079 0 172.155-1.034 172.155-2.31 0-1.275-105.57-1.853-172.155-1.853-66.584 0-172.155.578-172.155 1.854 0 1.275 77.076 2.31 172.155 2.31z",
  id: "phone_svg__f"
}), React.createElement("path", {
  d: "M63.804 2.22h261.34c16.123 0 24.954 1.707 34.164 6.635 8.673 4.641 15.597 11.569 20.236 20.248 4.925 9.214 6.63 18.05 6.63 34.183v662.877c0 16.132-1.705 24.968-6.63 34.183-4.64 8.678-11.563 15.606-20.236 20.247-9.21 4.928-18.04 6.635-34.164 6.635H63.804c-16.123 0-24.954-1.707-34.163-6.635-8.674-4.641-15.597-11.568-20.236-20.247-4.925-9.215-6.63-18.05-6.63-34.183V63.286c0-16.133 1.705-24.969 6.63-34.183 4.639-8.68 11.562-15.607 20.236-20.248 9.21-4.928 18.04-6.634 34.163-6.634z",
  id: "phone_svg__h"
}), React.createElement("path", {
  d: "M62.67 5.83h263.609c16.263 0 25.17 1.687 34.46 6.563 8.749 4.592 15.732 11.446 20.412 20.033 4.968 9.117 6.688 17.86 6.688 33.82v655.846c0 15.96-1.72 24.703-6.688 33.82-4.68 8.587-11.663 15.44-20.412 20.033-9.29 4.876-18.197 6.564-34.46 6.564H62.669c-16.263 0-25.17-1.688-34.46-6.564-8.749-4.592-15.732-11.446-20.411-20.033-4.968-9.117-6.688-17.86-6.688-33.82V66.246c0-15.96 1.72-24.703 6.688-33.82 4.679-8.587 11.662-15.44 20.411-20.033C37.5 7.517 46.406 5.83 62.67 5.83z",
  id: "phone_svg__l"
}), React.createElement("path", {
  d: "M66.842 4.441h254.155c15.68 0 24.267 1.697 33.223 6.597 8.436 4.615 15.169 11.504 19.68 20.133 4.79 9.163 6.448 17.949 6.448 33.99v659.127c0 16.04-1.658 24.827-6.448 33.99-4.511 8.629-11.244 15.517-19.68 20.132-8.956 4.9-17.544 6.597-33.223 6.597H66.842c-15.68 0-24.268-1.697-33.224-6.597-8.435-4.615-15.168-11.503-19.68-20.133-4.79-9.162-6.448-17.948-6.448-33.99V65.162c0-16.041 1.659-24.827 6.449-33.99 4.51-8.63 11.244-15.518 19.68-20.133 8.955-4.9 17.543-6.597 33.223-6.597z",
  id: "phone_svg__p"
}), React.createElement("path", {
  d: "M63.213 9.993h262.523c14.847 0 22.566 1.416 30.638 5.716 7.353 3.917 13.194 9.735 17.126 17.059 4.317 8.04 5.738 15.729 5.738 30.518v662.877c0 14.788-1.421 22.478-5.738 30.517-3.932 7.325-9.773 13.142-17.126 17.06-8.072 4.3-15.791 5.715-30.638 5.715H63.213c-14.847 0-22.567-1.416-30.638-5.715-7.353-3.918-13.194-9.735-17.127-17.06-4.316-8.04-5.738-15.729-5.738-30.517V63.286c0-14.79 1.422-22.478 5.738-30.518 3.933-7.324 9.774-13.142 17.127-17.06 8.071-4.299 15.79-5.715 30.638-5.715z",
  id: "phone_svg__t"
}), React.createElement("path", {
  d: "M2.7 0h35.662c.888 0 1.788.37 2.7 1.11H0C.913.37 1.813 0 2.7 0z",
  id: "phone_svg__v"
}), React.createElement("path", {
  d: "M22.865 758.067c-7.353-3.923-13.194-9.74-17.127-17.065C1.422 732.962 0 725.273 0 710.484V47.607C0 32.82 1.422 25.13 5.738 17.09 9.671 9.765 15.512 3.947 22.865.03 24.045-.598 5.46 8.317 5.46 44.831v668.43c0 35.095 17.953 45.093 17.404 44.806z",
  id: "phone_svg__x"
}), React.createElement("path", {
  d: "M369.476 758.067c-7.354-3.923-13.194-9.74-17.127-17.065-4.317-8.04-5.738-15.729-5.738-30.518V47.607c0-14.788 1.421-22.478 5.738-30.517 3.933-7.325 9.773-13.143 17.127-17.06 1.179-.628-17.404 8.287-17.404 44.801v668.43c0 35.095 17.953 45.093 17.404 44.806z",
  id: "phone_svg__z"
}), React.createElement("path", {
  d: "M1.937.007A1.94 1.94 0 000 1.949v23.86a1.94 1.94 0 001.937 1.943h1.107c0-1.46.018-26.319 0-27.745H1.937z",
  id: "phone_svg__C"
}), React.createElement("path", {
  d: "M1.937 50.81c-.63.155-1.385.552-1.788 1.116-.083.117-.15.484-.15.59v48.727c0 .114.093.687.15.826.326.8.893.994 1.788 1.457h1.107c0-1.46.018-51.29 0-52.716H1.937z",
  id: "phone_svg__F"
}), React.createElement("path", {
  d: "M1.937 116.598c-.63.155-1.385.552-1.788 1.116-.083.116-.15.483-.15.59v48.727c0 .113.093.686.15.825.326.8.893.995 1.788 1.458h1.107c0-1.46.018-51.29 0-52.716H1.937z",
  id: "phone_svg__H"
}), React.createElement("path", {
  d: "M390.885 68.028c-.63.155-1.385.552-1.788 1.116-.083.116-.149.484-.149.59v79.801c0 .114.093.687.15.826.326.8.893.994 1.787 1.457h1.107c0-1.459.019-82.364 0-83.79h-1.107z",
  id: "phone_svg__K"
}), React.createElement("path", {
  d: "M79.898 0c2.758 0 4.919 2.237 4.994 4.997.15 5.531.992 8.45 2.445 11.168a16.642 16.642 0 006.922 6.926c2.984 1.596 6.193 2.447 12.854 2.447h130.335c6.66 0 9.87-.85 12.854-2.447a16.642 16.642 0 006.921-6.926c1.454-2.72 2.287-5.628 2.446-11.168.08-2.76 2.236-4.997 4.993-4.997h38.284c14.47 0 19.718 1.507 25.008 4.336 5.29 2.829 9.442 6.98 12.27 12.27 2.83 5.29 4.337 10.538 4.337 25.008v662.917c0 14.47-1.507 19.717-4.336 25.007-2.83 5.29-6.981 9.442-12.271 12.271-5.29 2.83-10.538 4.336-25.008 4.336H41.614c-14.47 0-19.717-1.506-25.007-4.336-5.29-2.829-9.442-6.98-12.271-12.27-2.79-5.216-4.293-10.39-4.335-24.402L0 41.614c0-14.47 1.507-19.717 4.336-25.007 2.829-5.29 6.98-9.442 12.27-12.271C21.823 1.546 26.997.043 41.009 0z",
  id: "phone_svg__Z"
}), React.createElement("path", {
  id: "phone_svg__ac",
  d: "M0 0h344v58H0z"
}), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "phone_svg__g"
}, React.createElement("stop", {
  stopColor: "#C9C6C8",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#2C2A2A",
  offset: "1.683%"
}), React.createElement("stop", {
  stopColor: "#C9C6C8",
  offset: "7.825%"
}), React.createElement("stop", {
  stopColor: "#C9C6C8",
  offset: "92.056%"
}), React.createElement("stop", {
  stopColor: "#2C2A2A",
  offset: "98.043%"
}), React.createElement("stop", {
  stopColor: "#C9C6C8",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "6.403%",
  id: "phone_svg__k"
}, React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.7,
  offset: "0%"
}), React.createElement("stop", {
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "92.931%",
  id: "phone_svg__m"
}, React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.7,
  offset: "0%"
}), React.createElement("stop", {
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "98.845%",
  id: "phone_svg__o"
}, React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.75,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: ".02%",
  x2: "50%",
  y2: ".73%",
  id: "phone_svg__q"
}, React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.75,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "phone_svg__r"
}, React.createElement("stop", {
  stopColor: "#5F5F5F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#222",
  offset: "1.012%"
}), React.createElement("stop", {
  stopColor: "#252525",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "phone_svg__s"
}, React.createElement("stop", {
  stopColor: "#6D6D6D",
  offset: "0%"
}), React.createElement("stop", {
  offset: "1.612%"
}), React.createElement("stop", {
  offset: "98.47%"
}), React.createElement("stop", {
  stopColor: "#5C5C5C",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "27.182%",
  y1: "44.984%",
  x2: "54.669%",
  y2: "44.984%",
  id: "phone_svg__B"
}, React.createElement("stop", {
  stopColor: "#A5A5A5",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E2E2E2",
  offset: ".735%"
}), React.createElement("stop", {
  stopColor: "#BEBEBE",
  offset: "99.474%"
}), React.createElement("stop", {
  stopColor: "#9D9D9D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "27.182%",
  y1: "44.984%",
  x2: "54.669%",
  y2: "44.984%",
  id: "phone_svg__E"
}, React.createElement("stop", {
  stopColor: "#A5A5A5",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E2E2E2",
  offset: ".735%"
}), React.createElement("stop", {
  stopColor: "#BEBEBE",
  offset: "99.474%"
}), React.createElement("stop", {
  stopColor: "#9D9D9D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "34.549%",
  y1: "44.984%",
  x2: "36.094%",
  y2: "44.984%",
  id: "phone_svg__J"
}, React.createElement("stop", {
  stopColor: "#8E8E8E",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#BCBCBC",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "phone_svg__L"
}, React.createElement("stop", {
  stopOpacity: 0.997,
  offset: "0%"
}), React.createElement("stop", {
  stopOpacity: 0,
  offset: "9.512%"
}), React.createElement("stop", {
  stopOpacity: 0,
  offset: "89.546%"
}), React.createElement("stop", {
  stopOpacity: 0.881,
  offset: "100%"
})), React.createElement("radialGradient", {
  cx: "47.648%",
  cy: "98.993%",
  fx: "47.648%",
  fy: "98.993%",
  r: "60.295%",
  gradientTransform: "matrix(0 .48024 -.73004 0 1.2 .761)",
  id: "phone_svg__u"
}, React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.151,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("radialGradient", {
  cx: "121.058%",
  cy: "134.126%",
  fx: "121.058%",
  fy: "134.126%",
  r: "100.691%",
  gradientTransform: "matrix(.7045 .70929 -.7097 .7041 1.31 -.462)",
  id: "phone_svg__R"
}, React.createElement("stop", {
  stopColor: "#434343",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#121212",
  offset: "100%"
})), React.createElement("radialGradient", {
  cx: "50%",
  cy: "0%",
  fx: "50%",
  fy: "0%",
  r: "100.058%",
  gradientTransform: "matrix(0 .99942 -1 0 .5 -.5)",
  id: "phone_svg__U"
}, React.createElement("stop", {
  stopColor: "#2A4893",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#213054",
  offset: "100%"
})), React.createElement("rect", {
  id: "phone_svg__N",
  x: 0,
  y: 0,
  width: 43.278,
  height: 6.662,
  rx: 3.331
}), React.createElement("rect", {
  id: "phone_svg__P",
  x: 0,
  y: 0,
  width: 43.278,
  height: 6.662,
  rx: 3.331
}), React.createElement("ellipse", {
  id: "phone_svg__S",
  cx: 5.826,
  cy: 5.829,
  rx: 3.052,
  ry: 3.053
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#000"
}, React.createElement("use", {
  filter: "url(#phone_svg__a)",
  xlinkHref: "#phone_svg__b",
  transform: "translate(9.716 784.73)"
}), React.createElement("use", {
  filter: "url(#phone_svg__c)",
  xlinkHref: "#phone_svg__d",
  transform: "translate(9.716 784.73)"
}), React.createElement("use", {
  filter: "url(#phone_svg__e)",
  xlinkHref: "#phone_svg__f",
  transform: "translate(9.716 784.73)"
})), React.createElement("path", {
  d: "M69.914 0h261.34c16.476 0 25.646 1.779 35.21 6.897 9.06 4.848 16.3 12.093 21.146 21.158 5.115 9.57 6.893 18.745 6.893 35.23v662.878c0 16.485-1.778 25.66-6.893 35.23-4.845 9.066-12.085 16.31-21.146 21.159-9.564 5.117-18.734 6.896-35.21 6.896H69.914c-16.476 0-25.646-1.779-35.21-6.896-9.06-4.849-16.301-12.093-21.147-21.159-5.115-9.57-6.892-18.745-6.892-35.23V63.286c0-16.486 1.777-25.661 6.892-35.23 4.846-9.066 12.086-16.31 21.147-21.16C44.268 1.78 53.438 0 69.914 0z",
  fill: "#000"
}), React.createElement("g", {
  transform: "translate(6.665)"
}, React.createElement("use", {
  fill: "url(#phone_svg__g)",
  xlinkHref: "#phone_svg__h"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__i)",
  xlinkHref: "#phone_svg__h"
})), React.createElement("g", {
  filter: "url(#phone_svg__j)",
  transform: "translate(6.665)"
}, React.createElement("use", {
  fill: "url(#phone_svg__k)",
  xlinkHref: "#phone_svg__l"
}), React.createElement("use", {
  fill: "url(#phone_svg__m)",
  xlinkHref: "#phone_svg__l"
})), React.createElement("g", {
  opacity: 0.501,
  filter: "url(#phone_svg__n)",
  transform: "translate(6.665)"
}, React.createElement("use", {
  fill: "url(#phone_svg__o)",
  xlinkHref: "#phone_svg__p"
}), React.createElement("use", {
  fill: "url(#phone_svg__q)",
  xlinkHref: "#phone_svg__p"
})), React.createElement("path", {
  d: "M62.972 6.245c-15.482 0-23.7 1.575-32.266 6.16C22.733 16.67 16.384 23.022 12.12 31c-4.581 8.57-6.155 16.794-6.155 32.285v662.877c0 15.49 1.574 23.714 6.155 32.285 4.264 7.977 10.613 14.33 18.586 18.596 8.565 4.584 16.784 6.159 32.266 6.159h263.005c15.481 0 23.7-1.575 32.266-6.159 7.972-4.266 14.322-10.619 18.586-18.596 4.58-8.571 6.155-16.795 6.155-32.285V63.286c0-15.491-1.574-23.715-6.155-32.285-4.264-7.978-10.614-14.33-18.586-18.597-8.566-4.584-16.785-6.159-32.266-6.159H62.972z",
  stroke: "#000",
  strokeWidth: 0.832,
  fill: "url(#phone_svg__r)",
  transform: "translate(6.665)"
}), React.createElement("g", {
  transform: "translate(6.665)"
}, React.createElement("use", {
  fill: "url(#phone_svg__s)",
  xlinkHref: "#phone_svg__t"
}), React.createElement("use", {
  fill: "url(#phone_svg__u)",
  xlinkHref: "#phone_svg__t"
})), React.createElement("path", {
  d: "M70.469 14.99h261.34c14.196 0 21.037 1.321 28.145 5.125 6.45 3.451 11.551 8.556 15 15.01 3.802 7.111 5.123 13.956 5.123 28.16v662.878c0 14.205-1.32 21.049-5.122 28.16-3.45 6.455-8.551 11.56-15.001 15.01-7.108 3.804-13.949 5.126-28.145 5.126H70.469c-14.197 0-21.038-1.322-28.145-5.125-6.45-3.452-11.552-8.556-15.001-15.01-3.802-7.112-5.123-13.956-5.123-28.161V63.286c0-14.205 1.321-21.05 5.123-28.162 3.449-6.453 8.55-11.558 15-15.01 7.108-3.803 13.949-5.124 28.146-5.124z",
  fill: "#000",
  fillRule: "nonzero"
}), React.createElement("g", null, React.createElement("g", {
  transform: "translate(180.054 788.338)"
}, React.createElement("use", {
  fill: "#191919",
  xlinkHref: "#phone_svg__v"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__w)",
  xlinkHref: "#phone_svg__v"
}))), React.createElement("g", null, React.createElement("g", {
  transform: "translate(16.374 15.822)"
}, React.createElement("use", {
  fillOpacity: 0.6,
  fill: "#FFF",
  xlinkHref: "#phone_svg__x"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__y)",
  xlinkHref: "#phone_svg__x"
})), React.createElement("g", {
  transform: "matrix(-1 0 0 1 732.514 15.822)"
}, React.createElement("use", {
  fillOpacity: 0.6,
  fill: "#FFF",
  xlinkHref: "#phone_svg__z"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__A)",
  xlinkHref: "#phone_svg__z"
}))), React.createElement("g", {
  fill: "#000",
  opacity: 0.603
}, React.createElement("path", {
  d: "M6.665 69.674h6.38v4.719h-6.38zM389.233 69.674h5.27v4.719h-5.27zM6.665 715.056h6.38v4.719h-6.38zM389.233 715.056h5.27v4.719h-5.27zM321.263 6.384V0h4.716v6.384zM76.298 789.448v-6.384h4.716v6.384z"
})), React.createElement("g", null, React.createElement("g", {
  transform: "translate(5 97.71)"
}, React.createElement("use", {
  fill: "url(#phone_svg__B)",
  xlinkHref: "#phone_svg__C"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__D)",
  xlinkHref: "#phone_svg__C"
})), React.createElement("g", {
  transform: "translate(5 97.71)"
}, React.createElement("use", {
  fill: "url(#phone_svg__E)",
  xlinkHref: "#phone_svg__F"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__G)",
  xlinkHref: "#phone_svg__F"
})), React.createElement("g", {
  transform: "translate(5 97.71)"
}, React.createElement("use", {
  fill: "url(#phone_svg__E)",
  xlinkHref: "#phone_svg__H"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__I)",
  xlinkHref: "#phone_svg__H"
})), React.createElement("g", {
  transform: "matrix(-1 0 0 1 785.948 97.71)"
}, React.createElement("use", {
  fill: "url(#phone_svg__J)",
  xlinkHref: "#phone_svg__K"
}), React.createElement("use", {
  fill: "url(#phone_svg__L)",
  xlinkHref: "#phone_svg__K"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__M)",
  xlinkHref: "#phone_svg__K"
}))), React.createElement("g", null, React.createElement("g", {
  opacity: 0.801,
  transform: "translate(179.5 27.203)"
}, React.createElement("mask", {
  id: "phone_svg__O",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#phone_svg__N"
})), React.createElement("use", {
  fill: "#1D1C1C",
  xlinkHref: "#phone_svg__N"
}), React.createElement("path", {
  d: "M43.278 5.343v.486H0v-.486h43.278zm0-1.214v.486H0v-.486h43.278zm0-1.457v.486H0v-.486h43.278zm0-1.215v.486H0v-.486h43.278zm0-1.457v.486H0V0h43.278z",
  fillOpacity: 0.15,
  fill: "#000",
  mask: "url(#phone_svg__O)"
}), React.createElement("path", {
  d: "M43.278 6.454v.486H0v-.486h43.278zm0-1.215v.486H0V5.24h43.278zm0-1.457v.486H0v-.486h43.278zm0-1.214v.485H0v-.485h43.278zm0-1.458v.486H0V1.11h43.278z",
  fillOpacity: 0.03,
  fill: "#FFF",
  mask: "url(#phone_svg__O)"
}), React.createElement("path", {
  d: "M1.461.002V6.66H.969V.002h.492zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.491V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.491V.002h.492zm1.477 0V6.66H7.86V.002h.492zm1.23 0V6.66H9.09V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.493V.002h.493zm1.23 0V6.66h-.492V.002h.492zm1.476 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.493V.002h.493zm1.23 0V6.66H24.1V.002h.492zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.491V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.493zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.493V.002h.493zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492z",
  fillOpacity: 0.15,
  fill: "#000",
  mask: "url(#phone_svg__O)"
}), React.createElement("path", {
  d: "M.33.002V6.66h-.493V.002H.33zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66H4.02V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.493V.002h.493zm1.23 0V6.66h-.492V.002h.492zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.491V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.493zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.491V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.493V.002h.493zm1.23 0V6.66h-.492V.002h.492zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.491V.002h.492zm1.477 0V6.66h-.492V.002h.492zm1.477 0V6.66h-.493V.002h.493zm1.23 0V6.66h-.492V.002h.492zm1.476 0V6.66h-.492V.002h.492zm1.23 0V6.66h-.491V.002h.492z",
  fillOpacity: 0.03,
  fill: "#FFF",
  mask: "url(#phone_svg__O)"
}), React.createElement("use", {
  filter: "url(#phone_svg__Q)",
  xlinkHref: "#phone_svg__P",
  opacity: 0.244,
  fill: "#000"
})), React.createElement("g", {
  transform: "translate(233.597 24.15)"
}, React.createElement("ellipse", {
  fill: "url(#phone_svg__R)",
  cx: 5.826,
  cy: 5.829,
  rx: 5.826,
  ry: 5.829
}), React.createElement("mask", {
  id: "phone_svg__W",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#phone_svg__S"
})), React.createElement("g", {
  opacity: 0.388
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__T)",
  xlinkHref: "#phone_svg__S"
}), React.createElement("use", {
  fill: "url(#phone_svg__U)",
  xlinkHref: "#phone_svg__S"
})), React.createElement("path", {
  d: "M3.735 5.515c1.106 0 2.116.538 2.116-.054 0-.593-.038-.723-2.222-1.048C1.446 4.09.856 5.226.856 5.82c0 .592 1.773-.304 2.879-.304z",
  fill: "#3E89CC",
  filter: "url(#phone_svg__V)",
  mask: "url(#phone_svg__W)",
  transform: "rotate(-76 3.354 5.189)"
}), React.createElement("ellipse", {
  fill: "#1C5894",
  filter: "url(#phone_svg__X)",
  mask: "url(#phone_svg__W)",
  cx: 8.184,
  cy: 5.135,
  rx: 1.803,
  ry: 2.359
}), React.createElement("ellipse", {
  fill: "#0A152B",
  filter: "url(#phone_svg__Y)",
  mask: "url(#phone_svg__W)",
  transform: "rotate(-16 6.493 8.303)",
  cx: 6.493,
  cy: 8.303,
  rx: 2.774,
  ry: 1.804
}))), React.createElement("g", {
  transform: "translate(28.858 21.652)"
}, React.createElement("mask", {
  id: "phone_svg__aa",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#phone_svg__Z"
})), React.createElement("use", {
  fill: "#1D2129",
  xlinkHref: "#phone_svg__Z"
}), React.createElement("path", {
  fill: "#1D2129",
  mask: "url(#phone_svg__aa)",
  d: "M0 .555h344.561V746.7H0z"
}), React.createElement("path", {
  fill: "#FFF",
  mask: "url(#phone_svg__aa)",
  d: "M.142.348h345v755h-345z"
}), React.createElement("g", {
  mask: "url(#phone_svg__aa)"
}, React.createElement("g", {
  transform: "translate(.142 688.348)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#phone_svg__ab)",
  xlinkHref: "#phone_svg__ac"
}), React.createElement("use", {
  fillOpacity: 0.9,
  fill: "#FFF",
  xlinkHref: "#phone_svg__ac"
})), React.createElement("g", {
  fill: "#8492A6",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M176.247 703.316c1.507 0 2.729 1.23 2.73 2.72h2.282c.46 0 .84.342.896.792l.007.114c0 .5-.415.906-.903.906h-2.282l-.005.165a2.728 2.728 0 01-2.56 2.55l-.165.005a2.733 2.733 0 01-2.73-2.72h-8.653a.902.902 0 01-.902-.906c0-.5.414-.906.902-.906h8.653l.005-.165a2.728 2.728 0 012.559-2.55l.166-.005zm.91 1.813h-1.82v3.626h1.82v-3.626zm-7.28-10.877c1.507 0 2.729 1.23 2.73 2.72l8.652-.001c.46 0 .84.343.896.792l.007.114c0 .501-.415.907-.903.907h-8.653l-.004.164a2.728 2.728 0 01-2.56 2.55l-.165.005a2.733 2.733 0 01-2.73-2.719h-2.283a.902.902 0 01-.902-.907c0-.5.414-.906.902-.906h2.282l.006-.164a2.728 2.728 0 012.559-2.55l.166-.005zm.91 1.812h-1.82v3.626h1.82v-3.626zM163.49 724.619v-1.933h1.986v-.69h-1.985V720.6h2.172v-.715h-3.019v4.735h.847zm3.717 0v-4.735h-.846v4.735h.846zm3.913 0v-.716h-2.149v-4.02h-.846v4.736h2.995zm2.066 0v-4.02h1.437v-.715h-3.72v.715h1.437v4.02h.846zm5.16 0v-.716h-2.218v-1.352h2.097v-.672h-2.097v-1.28h2.218v-.715h-3.064v4.735h3.064zm1.666 0v-1.782h.938l.929 1.782h.968l-1.034-1.91c.565-.203.893-.725.893-1.352 0-.906-.614-1.473-1.638-1.473h-1.903v4.735h.847zm.978-2.432h-.978v-1.617h.958c.538 0 .866.308.866.807 0 .512-.308.81-.846.81z"
})), React.createElement("g", {
  fill: "#3C8EFF"
}, React.createElement("path", {
  d: "M55.463 703.316c.933 0 1.689.749 1.689 1.682v3.888c0 .929-.752 1.682-1.689 1.682H51.56a1.682 1.682 0 01-1.688-1.682v-3.888c0-.929.751-1.682 1.688-1.682h3.903zm9.1 0c.933 0 1.689.749 1.689 1.682v3.888c0 .929-.752 1.682-1.689 1.682H60.66a1.682 1.682 0 01-1.688-1.682v-3.888c0-.929.751-1.682 1.688-1.682h3.903zm-9.231 1.813h-3.64v3.626h3.64v-3.626zm9.1 0h-3.64v3.626h3.64v-3.626zm.131-10.877c.933 0 1.689.748 1.689 1.681v3.888c0 .93-.752 1.682-1.689 1.682H60.66a1.682 1.682 0 01-1.688-1.682v-3.888c0-.928.751-1.681 1.688-1.681h3.903zm-9.1 0c.933 0 1.689.748 1.689 1.681v3.888c0 .93-.752 1.682-1.689 1.682H51.56a1.682 1.682 0 01-1.688-1.682v-3.888c0-.928.751-1.681 1.688-1.681h3.903zm8.969 1.812h-3.64v3.626h3.64v-3.626zm-9.1 0h-3.64v3.626h3.64v-3.626z",
  "data-override": "fill"
}), React.createElement("path", {
  d: "M45.223 724.619c1.01 0 1.627-.512 1.627-1.346 0-.626-.453-1.09-1.096-1.151v-.027a1.05 1.05 0 00.863-1.03c0-.719-.554-1.181-1.414-1.181h-2.005v4.735h2.025zm-.364-2.74h-.814v-1.336h.948c.502 0 .788.233.788.647 0 .44-.332.689-.922.689zm.17 2.08h-.984v-1.48h.951c.647 0 .988.253.988.735 0 .486-.331.745-.955.745zm3.352.66v-1.782h.939l.928 1.782h.968l-1.033-1.91c.564-.203.892-.725.892-1.352 0-.906-.613-1.473-1.637-1.473h-1.903v4.735h.846zm.978-2.432h-.978v-1.617h.958c.539 0 .867.308.867.807 0 .512-.309.81-.847.81zm4.57 2.51c1.378 0 2.244-.938 2.244-2.444s-.866-2.448-2.244-2.448c-1.382 0-2.248.942-2.248 2.448s.866 2.444 2.248 2.444zm0-.721c-.847 0-1.382-.67-1.382-1.723 0-1.057.535-1.726 1.382-1.726.843 0 1.381.67 1.381 1.726 0 1.053-.538 1.723-1.381 1.723zm4.628.643l.968-3.426h.033l.968 3.426h.797l1.27-4.735h-.88l-.82 3.586h-.026l-.951-3.586h-.749l-.951 3.586h-.026l-.82-3.586h-.88l1.27 4.735h.797zm6.292.078c1.145 0 1.867-.564 1.867-1.463 0-.706-.407-1.103-1.368-1.322l-.545-.125c-.58-.138-.82-.322-.82-.637 0-.393.361-.656.896-.656.541 0 .912.266.951.709h.808c-.02-.834-.71-1.398-1.753-1.398-1.03 0-1.762.568-1.762 1.408 0 .676.414 1.096 1.287 1.296l.613.144c.597.141.84.338.84.68 0 .393-.397.675-.968.675-.577 0-1.014-.285-1.066-.722h-.82c.036.873.75 1.411 1.84 1.411zm5.653-.078v-.716h-2.219v-1.352h2.097v-.672h-2.097v-1.28h2.219v-.715h-3.065v4.735h3.065z",
  "data-override": "fill",
  fillRule: "nonzero"
})), React.createElement("g", {
  fill: "#8492A6",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M286.242 693.798c3.769 0 6.825 3.044 6.825 6.799 0 1.55-.522 2.98-1.399 4.123l4.94 4.921c.325.324.353.83.08 1.186l-.082.094a.91.91 0 01-1.284.002l-4.94-4.92a6.812 6.812 0 01-4.14 1.392c-3.77 0-6.825-3.044-6.825-6.798 0-3.755 3.055-6.799 6.825-6.799zm0 1.813c-2.765 0-5.005 2.232-5.005 4.986 0 2.753 2.24 4.985 5.005 4.985 2.764 0 5.005-2.232 5.005-4.985 0-2.754-2.241-4.986-5.005-4.986zM276.826 724.697c1.146 0 1.868-.564 1.868-1.463 0-.706-.407-1.103-1.369-1.322l-.544-.125c-.581-.138-.82-.322-.82-.637 0-.393.36-.656.895-.656.541 0 .912.266.952.709h.807c-.02-.834-.709-1.398-1.752-1.398-1.03 0-1.762.568-1.762 1.408 0 .676.413 1.096 1.286 1.296l.613.144c.598.141.84.338.84.68 0 .393-.397.675-.968.675-.577 0-1.013-.285-1.066-.722h-.82c.036.873.751 1.411 1.84 1.411zm5.653-.078v-.716h-2.218v-1.352h2.096v-.672h-2.096v-1.28h2.218v-.715h-3.065v4.735h3.065zm1.363 0l.404-1.224h1.742l.404 1.224h.892l-1.68-4.735h-.954l-1.68 4.735h.872zm1.946-1.877h-1.345l.663-2.021h.023l.66 2.02zm2.932 1.877v-1.782h.939l.928 1.782h.968l-1.033-1.91c.564-.203.892-.725.892-1.352 0-.906-.613-1.473-1.637-1.473h-1.903v4.735h.846zm.978-2.432h-.978v-1.617h.958c.539 0 .867.308.867.807 0 .512-.309.81-.847.81zm4.524 2.51c1.119 0 1.893-.613 2.04-1.627h-.83c-.13.57-.58.909-1.207.909-.82 0-1.339-.666-1.339-1.73 0-1.056.522-1.725 1.336-1.725.613 0 1.096.39 1.207.984h.834c-.105-1.017-.942-1.703-2.041-1.703-1.346 0-2.202.935-2.202 2.445 0 1.519.85 2.447 2.202 2.447zm3.611-.078v-2.054h2.303v2.054h.844v-4.735h-.844v1.969h-2.303v-1.97h-.847v4.736h.847z"
}))), React.createElement("rect", {
  fill: "#000",
  mask: "url(#phone_svg__aa)",
  x: 111.142,
  y: 735.548,
  width: 123,
  height: 4,
  rx: 2
})), React.createElement("g", null, React.createElement("path", {
  d: "M27 22h345v40.48H27z"
}), React.createElement("g", {
  transform: "translate(336.12 37.64)"
}, React.createElement("rect", {
  stroke: "#000",
  strokeWidth: 0.92,
  opacity: 0.35,
  x: 0.46,
  y: 0.767,
  width: 19.32,
  height: 9.507,
  rx: 2.453
}), React.createElement("path", {
  d: "M21.16 3.68v3.68a1.996 1.996 0 000-3.68",
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.4
}), React.createElement("rect", {
  fill: "#000",
  fillRule: "nonzero",
  x: 1.84,
  y: 2.147,
  width: 16.56,
  height: 6.747,
  rx: 1.227
})), React.createElement("path", {
  d: "M324.464 40.04c2.039 0 4 .783 5.477 2.187.11.109.289.108.398-.003l1.064-1.073a.296.296 0 00-.003-.42 10.026 10.026 0 00-13.873 0 .296.296 0 00-.003.42l1.064 1.073c.11.11.287.112.399.003a7.95 7.95 0 015.477-2.188zm0 3.491c1.12 0 2.2.417 3.03 1.168.113.107.29.105.4-.005l1.061-1.073a.297.297 0 00-.004-.422 6.587 6.587 0 00-8.972 0 .296.296 0 00-.004.422l1.062 1.073c.11.11.286.112.399.005a4.514 4.514 0 013.028-1.168zm2.041 2.562a.289.289 0 00-.008-.42 3.148 3.148 0 00-4.066 0 .289.289 0 00-.009.42l1.838 1.854a.287.287 0 00.408 0l1.837-1.854zM298.093 44.387h.92a.92.92 0 01.92.92v1.84a.92.92 0 01-.92.92h-.92a.92.92 0 01-.92-.92v-1.84a.92.92 0 01.92-.92zm4.294-1.84h.92a.92.92 0 01.92.92v3.68a.92.92 0 01-.92.92h-.92a.92.92 0 01-.92-.92v-3.68a.92.92 0 01.92-.92zm4.293-2.147h.92a.92.92 0 01.92.92v5.827a.92.92 0 01-.92.92h-.92a.92.92 0 01-.92-.92V41.32a.92.92 0 01.92-.92zm4.293-2.147h.92a.92.92 0 01.92.92v7.974a.92.92 0 01-.92.92h-.92a.92.92 0 01-.92-.92v-7.974a.92.92 0 01.92-.92z",
  fill: "#000",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M56.378 48.93c-1.846 0-3.282-1.099-3.558-2.716h2.015c.189.64.795 1.044 1.556 1.044 1.335 0 2.143-1.287 2.103-3.308h-.122c-.444.916-1.347 1.435-2.48 1.435-1.846 0-3.2-1.361-3.2-3.22 0-2.022 1.543-3.458 3.72-3.458 1.401 0 2.533.614 3.207 1.752.54.836.815 1.954.815 3.282 0 3.234-1.522 5.188-4.056 5.188zm.047-5.115c1.018 0 1.766-.721 1.766-1.698 0-.984-.762-1.745-1.76-1.745-.996 0-1.765.754-1.765 1.725 0 .997.742 1.718 1.76 1.718zm6.873 3.881c.728 0 1.193-.492 1.193-1.172 0-.68-.465-1.166-1.193-1.166-.72 0-1.192.485-1.192 1.166 0 .68.471 1.172 1.192 1.172zm0-4.973c.728 0 1.193-.492 1.193-1.172 0-.68-.465-1.166-1.193-1.166-.72 0-1.192.485-1.192 1.166 0 .68.471 1.172 1.192 1.172zm7.649 5.957v-1.698h-4.758v-1.8c.876-1.65 2.143-3.658 3.848-6.225h2.85v6.334h1.274v1.691h-1.274v1.698h-1.94zm-2.932-3.437v.108h2.979v-4.81h-.108a59.633 59.633 0 00-2.87 4.702zm9.798 3.437h2.035v-9.723H77.82l-2.513 1.731v1.894l2.385-1.644h.121v7.742z",
  fill: "#000"
})));

const SvgPhone = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 402,
  height: 808,
  viewBox: "0 0 402 808",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;